import { indexedMap } from '../../../utilities/miscellaneous'
import ImageThumbnailRendition from '../../../legacy_components/Image/Rendition/Thumbnail'
import React, { useEffect, useRef } from 'react'
import Widget from '../../../legacy_components/Article/Widget'
import Time from '../../../widgets/Temporal/Time'
import PropTypes from 'prop-types'
import styles from './List.module.css'
import { getLocales } from '../../../utilities/locales'

const ShowList = ({
  locale,
  schedules,
  shouldScrollToCurrent = false,
}) => {
  const now = new Date()
  const currentRef = useRef(null)

  useEffect(() => {
    if (currentRef.current && shouldScrollToCurrent) {
      currentRef.current.scrollIntoView({
        behavior: 'auto',
        block: 'start',
      })
    }
  }, [locale, schedules])

  return schedules.map(schedule => {
    const isCurrent = now < new Date(schedule.to) && now >= new Date(schedule.from)
    const isToday = new Date(schedule.from).toDateString() === now.toDateString()
    const isPast = isToday && new Date(schedule.to) < now

    return (
      <div
        ref={ isCurrent ? currentRef : null }
        data-is="show-list"
        key={ schedule.id }
        className={ isPast ? styles.past : undefined }
      >
        <aside>
          <h3 className={ styles['hour-title'] }>
            <span className={ styles.bullet }></span>
            <Time date={ schedule.from } locale={ locale } />
          </h3>
        </aside>
        <div className={ styles.schedule }>
          <div className={ styles['image-wrapper'] }>
            { schedule.show?.image
              ? <ImageThumbnailRendition
                src={ schedule.show.image.href }
                alt={ schedule.show.image.legend }
              />
              : null
            }
          </div>
          <div className={ styles['information-wrapper'] }>
            <h4 className={ styles['show-title'] }>
              { schedule.show.title }
              { isCurrent ? <span className={ styles['blinking-dot'] } /> : null }
            </h4>
            <div className={ styles['show-content'] }>
              { indexedMap((component, index) =>
                <Widget component={ component } id={ index } key={ index } />,
              )(schedule.show.parsedBody) }
            </div>
          </div>
        </div>
      </div>
    )
  })
}

ShowList.propTypes = {
  locale: PropTypes.oneOf(getLocales()).isRequired,
  schedules: PropTypes.arrayOf(PropTypes.object).isRequired,
  shouldScrollToCurrent: PropTypes.bool,
}

export default ShowList
